import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Sigle, useBranding } from "../branding";
import { api, useApiQuery } from "../api";
import { useAuthenticatedSession } from "../session";
import { AppLayout } from "./AppLayout";
import styles from "./AppLayout.module.css";
import { NAV_ESN, NAV_ESN_CONNEXIONS, NAV_ESN_CONSULTANTS, NAV_ESN_EQUIPE, NAV_ESN_FEUILLES, NAV_ESN_MARQUE, ROUTES } from "./routes";

/** L'espace de l'ESN : les entreprises clientes, la grille, et son équipe. */
export function EsnLayout() {
  const { permissions } = useAuthenticatedSession();
  const { product_short } = useBranding();

  useEffect(() => {
    const avant = document.title;
    document.title = `Espace ESN · ${product_short}`;
    return () => {
      document.title = avant;
    };
  }, [product_short]);

  // Les demandes en attente, en pastille sur l'entrée « Inscriptions » : une
  // lecture par navigation dans l'espace, donc à jour en quittant la file.
  // Une erreur de lecture n'affiche rien — la pastille est une commodité,
  // pas une donnée.
  const location = useLocation();
  const attente = useApiQuery((o) => api.listSignups({ status: "pending" }, o), [location.pathname]);
  const enAttente = attente.data?.signups.length;

  // Feuilles et consultants : tout compte ESN, le commercial fait travailler
  // ses consultants. L'équipe ESN elle-même reste aux administrateurs.
  const items = [
    ...NAV_ESN.map((item) => (item.to === ROUTES.esnInscriptions ? { ...item, count: enAttente } : item)),
    NAV_ESN_FEUILLES,
    NAV_ESN_CONSULTANTS,
  ];
  if (permissions.can_manage_esn) {
    items.push(NAV_ESN_EQUIPE, NAV_ESN_CONNEXIONS, NAV_ESN_MARQUE);
  }

  return (
    <AppLayout
      navItems={items}
      brand={
        <>
          <Sigle />
          <span className={styles.nomProduit}>
            <strong>Espace ESN</strong>
            <span>Entreprises clientes et portefeuilles</span>
          </span>
        </>
      }
    />
  );
}
